import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/user/auth'
import { getResponse, getError } from '@/composables/api'
import { useToastsStore } from '@/stores/notifications/toasts'
import { useFilesStore } from '@/stores/ginnels/files'
import { useGinnelStore } from '@/stores/ginnels/ginnel'
import axios from 'axios'

export const useUserTagsStore = defineStore({
   id: 'user-tags',
   state: () => ({
      tags: [],

      storeAuth: useAuthStore(),
      storeToasts: useToastsStore(),
      storeFiles: useFilesStore(),
      storeGinnel: useGinnelStore(),
   }),
   actions: {
      getTags() {
         axios.get('user-tags')
         .then((response) => {
            this.tags = getResponse(response)
         })
      },
      add(tagName) {
         if(this.tags.find(tag => tag.name == tagName)) {
            this.storeToasts.sendToast('Tag already exists', 'warning')
            return
         }

			axios.post('user-tag', { name: tagName }).then(response => {
            this.tags.push(getResponse(response))
            this.storeToasts.sendToast('A new tag has been created', 'success')

			}).catch(response => {
            this.storeToasts.sendToast(getError(response) ?? 'Unknown Error.', 'danger')
         })
      },
      delete(slug) {
         axios.delete('user-tag', { params: { slug: slug } }).then((response) => {

             // Find the index
            const fileIndex = this.tags.findIndex(tag => tag.slug == slug);
            if (fileIndex !== -1) this.tags.splice(fileIndex, 1)

            // Fetch fresh files
            this.storeFiles.taggedFiles()

            // Clear the cache, so we get fresh data
            this.storeGinnel.unsetCachedGinnels()

            this.storeToasts.sendToast('Deleted successfully.')

         }).catch((error) => {
             this.storeToasts.sendToast(getError(error) ?? 'Unknown Error.', 'danger');
         });
     },
   }
})